<template lang="pug">
	.proposal-builder-holder
		.proposal-builder
			Stepper(ref="stepper", :steps="activeSteps", :actions="stepper.actions", :initialSteps="stepper.currentStepIndexes", @step-changed="(s, v) => { stepper.currentStep = s; stepper.currentStepIndexes = v; }", :hideStepNumbers="true")
				.flex-row.full-width.justify
					.left
					.right.flex-row.space
						.status(v-if="status")
							.px-loader.loading.flex-row.space
								.loader
									i.fas.fa-circle-notch.fa-spin
								span {{status}}
						.products.flex-row.nowrap.space.align-center(v-if="stepper.currentStepIndexes[0] === 0 && [4,5].indexOf(stepper.currentStepIndexes[1]) > -1")
							.font-small.upper.grey {{$tCaption('Products')}}:
							.product.nowrap(v-for="prod in selectedProductNames") {{prod}}
				.radio-map-actions(v-if="currentStep && currentStep.id === 'radio-map'", slot="actions")
					DxButton(:text="$tCaption('Clear')", icon="close", @click="v => data.radios = []")
			DxScrollView(showScrollbar="always", direction="both").scroll-view
				.content
					template(v-if="stepper.currentStep")
						template(v-for="comp in stepper.currentStep.components")
							component(
								ref="currentComponent",
								:is="comp.cmp()",
								v-bind="getProps(comp)",
								@data-change="(name, v) => data[name] = v",
								@data-where-change="(v) => data.regionsWhereClause = v",
								@map-position-change="(v) => lastMapPosition = v",
								@regions-change="(v) => data.regions = v",
								@page-status="changePageStatus")
</template>

<script>
	import _ from 'lodash';
	import CartoMap from 'view/carto/CartoMap.vue';
	import RadioMap from 'view/carto/RadioMap.vue';
	import GeoFencingMap from 'view/carto/GeoFencingMap.vue';
	import RegionSelectorMap from 'view/carto/RegionSelectorMap.vue';
	import AudienceSelection from './AudienceSelection.vue';
	import IABCategoriesSelection from './IABCategoriesSelection.vue';
	import KeywordsSelection from './KeywordsSelection.vue';
	import BudgetSelection from './BudgetSelection.vue';
	import ProductSelection from './ProductSelection.vue';
	import ProposalInfo from './ProposalInfo.vue';
	import PodcastsSelection from './PodcastsSelection.vue';
	import RadioSchedule from './RadioSchedule.vue';
	import DxScrollView from 'devextreme-vue/scroll-view';
	import BuilderStep from './BuilderStep.vue';
	import DxButton from 'devextreme-vue/button';
	import DxDropDownButton from 'devextreme-vue/drop-down-button';
	import auth from 'src/auth';
	import Stepper from './Stepper.vue';
	import Data from 'app-core/Data';
	import StreamingsSelection from './StreamingsSelection.vue';
	import PackagesSelection from './PackagesSelection.vue';
	import PackagesSelectionInfo from './PackagesSelectionInfo.vue';
	import VueTypes from 'vue-types';

	export default {
		translationCategory: 'proposal.Builder',
		name: 'proposal-builder',
		components: {
			CartoMap,
			RegionSelectorMap,
			AudienceSelection,
			DxScrollView,
			IABCategoriesSelection,
			BudgetSelection,
			KeywordsSelection,
			BuilderStep,
			DxButton,
			DxDropDownButton,
			ProductSelection,
			ProposalInfo,
			RadioSchedule,
			Stepper,
			PodcastsSelection,
			StreamingsSelection,
			GeoFencingMap
		},
		props: {
			proposalData: VueTypes.object.def(null)
		},
		data() {
			return {
				stepper: {
					currentStepIndexes: [0, 0],
					currentStep: null,
					actions: {
						items: [
							{
								name: () => { return this.data.oid ? this.$tCaption('Update proposal') : this.$tCaption('Create proposal'); },
								handler: () => {
									this.createProposal();
								}
							}
						],
						getVisibility: (action, mainStep) =>  {
							return mainStep > 0;
						},
						getDisabled: () => {
							return !!this.status;
						}
					}
				},
				lastMapPosition: {},
				data: {
					oid: null,
					totalPopulation: 0,
					selectedPopulation: 0,
					filterGenderMale: false,
					filterGenderFemale: false,
					filterAgeUnder18: false,
					filterAge18_24: false,
					filterAge25_34: false,
					filterAge35_44: false,
					filterAge45_54: false,
					filterAge55_64: false,
					filterAgeOver65: false,
					filterHouseholdUnder50: false,
					filterHousehold50_100: false,
					filterHousehold100_150: false,
					filterHouseholdOver150: false,
					filterEducationNoCollege: false,
					filterEducationCollege: false,
					filterEducationGradSchool: false,
					filterParentingHasKids: false,
					filterParentingNoKids: false,
					zips: [],
					iabCategories: [],
					budget: null,
					keywords: [],
					products: [],
					productsInfo: [],
					opportunityOwner: null,
					opportunityOwnerOid: null,
					advertiserName: null,
					advertiserOid: null,
					advertiserIndustry: null,
					advertiserIndustryCode: null,
					name: null,
					presentationDate: new Date(),
					radios: [],
					radioScheduleFile: null,
					radioSpots: 0,
					radioCost: 0,
					authorOid: null,
					author: null,
					packageCountry: null,
					packageState: null,
					packageCity: null,
					packageBudget: null,
					packageDayparts: [],
					packageStartDate: null,
					packageSpotLength: null,
					packages: [],
					regionsWhereClause: null,
					regions: [],
					geoFencingPoints: [],
					imageGeographies: null,
					imageGeotargeting: null,
					imageGeofencing: null,
					statistics: null,
					geoTargetingCircleFilter: null,
					geoTargetingPolygonFilter: null,
					customZips: {
						added: [],
						removed: []
					},
					contactOid: null,
					contactName: null,
					targeting: []
				},
				products: [],
				status: null
			};
		},
		computed: {
			currentStep() {
				return this.$refs.stepper && this.$refs.stepper.currentSubStep;
			},
			activeSteps() {
				return this.steps.filter(f => !f.hidden || !f.hidden()).map(f => {
					return {
						...f,
						steps: f.steps.filter(f => !f.hidden || !f.hidden())
					};
				});
			},
			selectedProductNames() {
				return this.products.filter(f => this.data && this.data.products.indexOf(f.oid) > -1).map(f => f.name);
			},
			selectedProductTypes() {
				return this.products.filter(f => this.data && this.data.products.indexOf(f.oid) > -1).map(f => f.id);
			},
			selectedProducts() {
				return this.products.filter(f => this.data && this.data.products.indexOf(f.oid) > -1);
			},
			steps() {
				return [
					{
						name: this.$tCaption('Target'),
						icon: 'dx-icon dx-icon-filter',
						steps: [
							{ name: this.$tCaption('Proposal'), components: [{ cmp: () => ProposalInfo }], canNext: () => !!this.data.name && this.data.advertiserOid && this.data.presentationDate && this.data.advertiserIndustryCode && this.data.opportunityOwnerOid && this.data.contactOid },
							{ name: this.$tCaption('Product'), components: [{ cmp: () => ProductSelection }], canNext: () => this.data.products.length },
							...this.selectedProducts.filter(f => f.id === 'podcast').map((f) => (
								{
									name: f.name,
									components: [{ cmp: () => PodcastsSelection, props: () => ({ productId: f.oid, productInfo: this.data.productsInfo.filter(p => p.oid === f.oid)[0] }) }],
									canNext: () => this.data.productsInfo.filter(p => p.oid === f.oid)[0] && this.data.productsInfo.filter(p => p.oid === f.oid)[0].podcasts && this.data.productsInfo.filter(p => p.oid === f.oid)[0].podcasts.length
								}
							)),
							...this.selectedProducts.filter(f => f.lineType === 2).map((f) => (
								{
									name: `${this.$tCaption('Streamings')} (${f.name})`,
									components: [{ cmp: () => StreamingsSelection, props: () => ({ productId: f.oid, productInfo: this.data.productsInfo.filter(p => p.oid === f.oid)[0] }) }],
									hidden: () => this.$getSetting('proposal.streamingsSelectionStep.visible') === false,
									canNext: () => this.data.productsInfo.filter(p => p.oid === f.oid)[0] && this.data.productsInfo.filter(p => p.oid === f.oid)[0].streamings && this.data.productsInfo.filter(p => p.oid === f.oid)[0].streamings.length
								}
							)),
							{ name: this.$tCaption('Radio schedule'), components: [{ cmp: () => RadioSchedule }], hidden: () => this.$getSetting('proposal.radioScheduleStep.visible') === false },
							{ name: this.$tCaption('Packages filter'), components: [{ cmp: () => PackagesSelection }], hidden: () => this.$getSetting('proposal.packagesSelectionStep.visible') === false },
							{ name: this.$tCaption('Packages selection'), components: [{ cmp: () => PackagesSelectionInfo }], hidden: () => this.$getSetting('proposal.packagesSelectionStep.visible') === false },
							{ name: this.$tCaption('Stations map'), id: 'radio-map', components: [{ cmp: () => RadioMap }], hidden: () => this.$getSetting('proposal.networkSelectionStep.visible') === false || true },
							{ name: this.$tCaption('Geographies'), components: [{ cmp: () => RegionSelectorMap }], canNext: () => this.data.regions.length  && this.data.imageGeographies || true },
							{ name: this.$tCaption('Geo Targeting'), components: [{ cmp: () => CartoMap }], canNext: () => this.data.totalPopulation > 0 && this.data.imageGeotargeting || true },
							{ name: this.$tCaption('Geo Fencing'), components: [{ cmp: () => GeoFencingMap }], canNext: () => !this.data.geoFencingPoints.length || this.data.imageGeofencing },
							{ name: this.$tCaption('Audience'), components: [{ cmp: () => IABCategoriesSelection },  { cmp: () => AudienceSelection }]},
							{ name: this.$tCaption('Keywords'), components: [{ cmp: () => KeywordsSelection }] }
						]
					},
					{
						name: this.$tCaption('Budget'),
						icon: 'dx-icon dx-icon-money',
						steps: [
							{ name: this.$tCaption('Budget options'), components: [{ cmp: () => BudgetSelection }] }
						]
					},
					{
						name: this.$tCaption('Preview'),
						icon: 'dx-icon dx-icon-search',
						steps: [
							{ name: this.$tCaption('Preview'), components: [{ cmp: () => BudgetSelection }] }
						]
					}
				];
			}
		},
		mounted() {
			if (__DEBUG__)
				window.builder = this;
			this.data.author = auth.displayUserName();
			this.data.authorOid = auth.userId();
			Data.loadProducts().then(r => this.products = r);
			if (this.proposalData)
				_.assign(this.data, this.proposalData);
		},
		methods: {
			getProps(comp) {
				return {
					mapPosition: this.lastMapPosition,
					regions: this.data.regions,
					data: this.data,
					products: this.products,
					electedProductNames: this.selectedProductNames,
					...((comp.props && comp.props()) || {})
				};
			},
			changePageStatus(newStatus) {
				this.status = newStatus;
			},
			createProposal() {
				var proposal = {
					...this.data,
					iabCategoriesNames: this.data.iabCategories.map(f => f.Name)
				};
				this.status = () => this.$tCaption('Creating proposal');
				return Data.createProposal(proposal).then((oid) => {
					if (__DEBUG__)
						console.debug('Proposal synced', { oid });

					this.$notify(`${proposal.name || this.$tCaption('Proposal')} ${this.data.oid ? 'updated' : 'created'}`, 'success', 600);
					if (!this.data.oid)
						this.data.oid = oid;
					this.status = null;
				});
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.proposal-builder-holder {
		position: relative;
	}

	.proposal-builder {
		.products {
			margin: 0px 10px;

			> .product {
				padding: 5px 10px;
				background: rgba(0,0,0,0.05);
				border-radius: 4px;
			}
		}
		.scroll-view {
			height: calc(100vh - 243px);
		}

		.dx-scrollable-scrollbar {
			> .dx-scrollable-scroll > .dx-scrollable-scroll-content {
				background: $base-accent-transparent;
			}
		}

		.content-block.header {
			padding-top: 5px;
			padding-left: 10px;
			font-size: 24px;

			.dx-button-text {
				font-size: 30px;
				font-weight: 100;
				letter-spacing: 0;
				text-transform: initial;
			}
		}
	}

	.dx-slider-handle .dx-tooltip-wrapper .dx-overlay-content .dx-popup-content {
		text-overflow: inherit !important;
	}

	.header-data {
		display: flex;
		align-items: center;
		overflow: auto;

		> .header {
			margin: 10px 20px 10px 40px;
		}
	}

	.widgets-row {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
	}

	.widgets-area {
		padding: 0px 4px 10px 4px;

		&.segment {
			background: #fff;
			margin: 4px;
			border-radius: 4px;
		}
	}

	.widgets-col {
		display: flex;
		flex-direction: column;
	}

	.widgets {
		width: 100%;
	}

	.widget {
		margin: 10px 5px 0px 5px;
		padding: 10px;

		.header {
			font-size: 16px;

			&.label {
				font-size: 12px;
				color: #c1c1c1;
				text-transform: uppercase;
			}
		}

		.data-statistic {
			font-weight: 400;
			font-size: 21.5px;
		}

		.data-vertical {
			display: flex;
			flex-direction: column;
			padding-top: 10px;

			> * {
				margin-bottom: 10px;
			}
		}

		&.large {
			width: 710px;
			max-width: 80%;
		}

		.data-horizontal {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
		}
	}

	.dx-scrollable-scrollbar {
		z-index: 1000;
	}
</style>
